// 在标准 375px 适配下，100px = 1rem;
let baseFontSize = 192;
let baseWidth = 1920;
let set = function () {
  let clientWidth = document.documentElement.clientWidth || window.innerWidth;
  let rem = 192;
  if (clientWidth != baseWidth) {
    rem = (clientWidth / baseWidth) * baseFontSize;
  }
  if (rem < 140) {
    rem = 140;
  }
  document.querySelector("html").style.fontSize = rem + "px";
};
set();
window.addEventListener("resize", set);
